module.exports = __webpack_public_path__ + "assets/img/dzh-28.f85bcc03.gif";